/* eslint-disable */
// @ts-nocheck
import { Base64 } from 'js-base64';

import '../../../assets/libs/cadesplugin_api';

// not used
// ToDo: delete ?
// const CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1;
// const CADESCOM_CONTAINER_STORE = 100;

const CADESCOM_ENCODE_BASE64 = 0;
export const isEdge = navigator.userAgent.match(/Edge\/./i);

export interface ICertificateItem {
  info: string;
  value: string;
  binary: any;
  serialNumber: string;
}

export function print2Digit(digit: number): string {
  return digit < 10 ? `0${digit}` : digit.toString();
}

function getCertDate(certDate: Date): string {
  return `${print2Digit(certDate.getUTCDate())}.${print2Digit(certDate.getMonth() + 1)}.${certDate.getFullYear()}`;
}

function extractCertInfo(from: string, what: string): string {
  let certName = '';
  const begin = from.indexOf(what) + what.length;

  if (begin >= 0) {
    const end = from.indexOf(', ', begin);

    certName = end < 0 ? from.substr(begin) : from.substr(begin, end - begin);
    if (certName[0] === '"' && certName[certName.length - 1] === '"') {
      certName = certName.substr(1, certName.length - 2);
    }
    certName = certName.split('""').join('"');
  }

  return certName;
}

function getCertInfoString(
  serialNumber: string,
  certSubjectName: string,
  certFromDate: Date,
  certToDate: Date,
): string {
  return `${serialNumber}; ${certSubjectName}; ${getCertDate(certFromDate)}-${getCertDate(certToDate)};`;
}

// not used
// ToDo: delete ?
// function createObject(name: string): Promise<any> {
//   return cadesplugin.CreateObjectAsync
//     ? cadesplugin.CreateObjectAsync(name)
//     : new Promise((resolve, reject) => {
//         const obj = cadesplugin.CreateObject(name);

//         resolve(obj);
//       });
// }

export async function getCertificates(): Promise<Array<ICertificateItem>> {
  let val;
  try {
    await init();

    const oStore = await cadesplugin.CreateObjectAsync('CAdESCOM.Store');

    await oStore.Open();

    const certificatesPromise = await oStore.Certificates;
    const certCount = await certificatesPromise.Count;

    await oStore.Close();

    val = transformCertificates(certificatesPromise, certCount);
  } catch (err) {
    console.info('err of getCertificates', err);
    return err;
  }
  // await val.then(result => console.info('val of getCertificates', result));

  return val;
}

async function transformCertificates(certificatesPromise: any, certCount: any): Promise<Array<ICertificateItem>> {
  const certificates: Array<ICertificateItem> = [];

  try {
    for (let i = 1; i <= certCount; i += 1) {
      const certificate = await certificatesPromise.Item(i);
      const validFrom = new Date(await certificate.ValidFromDate);
      const validTo = new Date(await certificate.ValidToDate);
      const subjectName = await certificate.SubjectName;
      const serialNumber = await certificate.SerialNumber;
      const validator = await certificate.IsValid();
      const isValid = await validator.Result;
      const name = extractCertInfo(subjectName, 'CN=');
      const certificateInfo = getCertInfoString(serialNumber, name, validFrom, validTo);
      const binary = await certificate.Export(CADESCOM_ENCODE_BASE64);

      if (isValid) {
        certificates.push({
          info: certificateInfo,
          value: certificate,
          binary,
          serialNumber,
        });
      }
    }
  } catch (e) {
    return certificates;
  }

  return certificates;
}

export function init(): Promise<any> {
  return new Promise((resolve, reject) => {
    if (cadesplugin.CreateObjectAsync) {
      cadesplugin.then(
        function () {
          resolve();
        },
        function (error: any) {
          reject(error);
        },
      );
    } else {
      window.addEventListener(
        'message',
        function (event) {
          if (event.data === 'cadesplugin_loaded') {
            resolve();
          } else if (event.data === 'cadesplugin_load_error') {
            reject(event);
          }
        },
        false,
      );
      window.postMessage('cadesplugin_echo_request', '*');
    }
  });
}

export async function subscribe(dataToSign: string, signType: number, certificate: string) {
  await init();
  const oSigner = await cadesplugin.CreateObjectAsync('CAdESCOM.CPSigner');

  await oSigner.propset_Certificate(certificate);

  const oSignedData = await cadesplugin.CreateObjectAsync('CAdESCOM.CadesSignedData');

  await oSignedData.propset_ContentEncoding(cadesplugin.CADESCOM_BASE64_TO_BINARY);
  await oSignedData.propset_Content(Base64.encode(dataToSign));

  let result = '';

  try {
    result = await oSignedData.SignCades(oSigner, signType, true);
  } catch (err) {
    alert(`Не удалось создать подпись из-за ошибки: ${cadesplugin.getLastError(err)}`);
    throw err;
  }

  return result;
}
